import { IResponseModel } from "../../IResponseModel";

export class EmailVerificationResendResponse implements IResponseModel {
}